import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const fetchDataArps = async (uri: any) => {
  const response = await fetch(`${REACT_APP_ARPS_BASE_URL}/${uri}`);
  return await response.json();
};

export default fetchDataArps;
